<div class="dummy">    
    <img src="/images/templates/visitor/logo.png">
    <div style="text-align: center;">Сайт зачинено на тех. обслуговування <br> Приносимо щирі вибачення за незручності, будь ласка. Обіцяємо скоро повернутися.</div>
    <div>Site closed for maintenance</div>    
</div>
